import {
  SAVE_PROGRESS_START,
  SAVE_PROGRESS_STEP,
  SAVE_PROGRESS_CLEAR,
  SAVE_ADD_ERROR,
  SAVE_CLEAR_ERRORS
} from '../constants/actions';

export const INITIALSTATE = {total: 0, complete: 0, errors: []};

export default (state = INITIALSTATE, action) => {
  switch(action.type) {
    case SAVE_PROGRESS_START:
      return Object.assign({}, state, { total: action.payload, complete: 0 });
    case SAVE_PROGRESS_STEP:
      return Object.assign({}, state, { complete: state.complete + 1 });
    case SAVE_PROGRESS_CLEAR:
      return Object.assign({}, state, { total: 0, complete: 0 });
    case SAVE_ADD_ERROR:
      return Object.assign({}, state, { errors: [...state.errors, action.payload] });
    case SAVE_CLEAR_ERRORS:
      return Object.assign({}, state, { errors: [] });
    default:
      return state;
  }
}

export const getSaveStatus = (state) => state.portal.saveStatus;
